/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface ReceiveWebhookRequest {
    ingressToken: string;
    body: string;
    authorization?: string;
}

/**
 * IntegrationsWebhookIngressApi - interface
 * 
 * @export
 * @interface IntegrationsWebhookIngressApiInterface
 */
export interface IntegrationsWebhookIngressApiInterface {
    /**
     * 
     * @summary Receive external webhook payload for integration instance
     * @param {string} ingressToken 
     * @param {string} body 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsWebhookIngressApiInterface
     */
    receiveWebhookRaw(requestParameters: ReceiveWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Receive external webhook payload for integration instance
     */
    receiveWebhook(requestParameters: ReceiveWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationsWebhookIngressApi extends runtime.BaseAPI implements IntegrationsWebhookIngressApiInterface {

    /**
     * Receive external webhook payload for integration instance
     */
    async receiveWebhookRaw(requestParameters: ReceiveWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['ingressToken'] == null) {
            throw new runtime.RequiredError(
                'ingressToken',
                'Required parameter "ingressToken" was null or undefined when calling receiveWebhook().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling receiveWebhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }


        let urlPath = `/v1/integrations/webhooks/{ingressToken}`;
        urlPath = urlPath.replace(`{${"ingressToken"}}`, encodeURIComponent(String(requestParameters['ingressToken'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Receive external webhook payload for integration instance
     */
    async receiveWebhook(requestParameters: ReceiveWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.receiveWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
